import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { NSPanel, NSBoxEmail, NSButtonBlue, NSSection, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountLayout } from "../AccountLayout";
import { AccountRoutes } from "../AccountRoutes";

interface PasswordForgetPageProps extends NSARouterMakerResult
{ }

interface PasswordForgetPageState
{
    sent: boolean;
}

function PasswordForgetPage(props: PasswordForgetPageProps) 
{
    const NSBoxEmail_Email = useRef<NSBoxEmail>(null);

    const [state, setState] = useState<PasswordForgetPageState>({ sent: false });

    function onClick(onFinished: () => void)
    {
        try
        {
            let email: string = NSBoxEmail_Email.current?.getValue() ?? "";
            props.account.server.password.Forget({ email }).then(() =>
            {

                setState({ sent: true });
                props.notifier.onSuccess("The request was made successfully.");
                onFinished();
            }).catch(onFinished);
        } catch (error)
        {
            props.notifier.onError(error as Error);
            onFinished();
        }
    }

    return (
        <AccountLayout {...props}
            title={{
                title: 'Forget Password',
                description: 'Enter the email you used, when registering, to reset you password and log in to your Namirasoft Account.'
            }} >
            <NSSection>
                <NSPanel>
                    <NSBoxEmail
                        ref={NSBoxEmail_Email}
                        title="Email"
                        required={true}
                        placeholder="Please enter your email"
                    />
                </NSPanel>
                <NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
                {
                    !state.sent ?
                        <>
                            <NSButtonBlue
                                title="Request Password Reset"
                                onClick={{
                                    action: (onFinished) =>
                                    {
                                        onClick(onFinished);
                                    }
                                }}
                            />
                            <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                        </>
                        : <></>
                }
                <Link to={props.url.getLink(AccountRoutes.Login, [])} className="nsa-font-16-bold nsa-color-blue">Back to Login</Link>
            </NSSection>
        </AccountLayout>
    );
}

export default PasswordForgetPage;